
import CenterImg from '@/components/centerImg/centerImg.vue'
import Card from '@/components/productCard/productCard.vue'
import PreviewImg from '@/components/previewImg/previewImg.vue'
export default {
  // 注入的依赖方法，用于改变header的相关设置
  inject:['showFooter','switchHeaderStatus'],
  head() {
    return {
      script: [
        { src: 'https://hm.baidu.com/hm.js?bca287ea2f695c8758d364d29d58ef85' }
      ]
    }
  },
  data(){
    return{
      currentClass: 1,
      // 分类列表
      classList: [
        { id: 1, selected: true, title: '全部' },
        { id: 2, selected: false, title: '液态硅胶LSR产品' },
        { id: 3, selected: false, title: '双色包胶注塑件' },
        { id: 4, selected: false, title: '工业塑胶制品' },
        { id: 5, selected: false, title: '硅橡胶制品' },
        { id: 6, selected: false, title: '防水外壳组装件' },
        { id: 7, selected: false, title: '触控面板系列' },
        // { id: 8, selected: false, title: '触摸屏面板' },
        { id: 10, selected: false, title: '汽车配件制品' },
        { id: 11, selected: false, title: '医疗配件制品' },
        { id: 9, selected: false, title: '精密模具展示' },
      ],
      // 所有的产品列表
      productList: [
      ],
      allProducts: [
        {id: 1, class: 2, title: '防水一体面壳', img: require('../assets/img/products/product_1.jpg')},
        {id: 2, class: 3, title: '万用表外壳', img: require('../assets/img/products/product_2.jpg')},
        {id: 3, class: 3, title: 'GPS测试仪外壳', img: require('../assets/img/products/product_3.jpg')},
        {id: 4, class: 2, title: '食品级幼儿奶嘴', img: require('../assets/img/products/product_4.jpg')},
        {id: 5, class: 5, title: '橡胶防尘防水密封饰盖', img: require('../assets/img/products/product_5.jpg')},
        {id: 6, class: 5, title: '汽车波纹管', img: require('../assets/img/products/product_6.jpg')},
        {id: 7, class: 5, title: '橡胶制品', img: require('../assets/img/products/product_7.jpg')},
        {id: 8, class: 2, title: '婴儿汤匙', img: require('../assets/img/products/product_8.jpg')},
        {id: 9, class: 3, title: '高光亮透明包胶电子仪表板', img: require('../assets/img/products/product_9.jpg')},
        {id: 10, class: 3, title: '防水手机外壳', img: require('../assets/img/products/product_10.jpg')},
        {id: 11, class: 6, title: '磁波高穿透防水防尘外壳', img: require('../assets/img/products/product_11.jpg')},
        {id: 12, class: 6, title: '户外 GPS 防水外壳', img: require('../assets/img/products/product_12.jpg')},
        {id: 13, class: 3, title: '双色万用表仪器外壳', img: require('../assets/img/products/product_13.jpg')},
        {id: 14, class:3, title: '抗摔防水手持外壳', img: require('../assets/img/products/product_14.jpg')},
        {id: 15, class: 3, title: '热显像仪塑胶壳', img: require('../assets/img/products/product_15.jpg')},
        {id: 16, class: 3, title: 'GPS测试仪外壳', img: require('../assets/img/products/product_16.jpg')},
        {id: 17, class: 10, title: '汽车电脑屏', img: require('../assets/img/products/product_17.jpg')},
        {id: 18, class: 3, title: '防静电智能测试仪外壳', img: require('../assets/img/products/product_18.jpg')},
        {id: 19, class: 4, title: 'GPS 机顶盒', img: require('../assets/img/products/product_19.jpg')},
        {id: 20, class: 4, title: '感温调试器外壳', img: require('../assets/img/products/product_20.jpg')},
        {id: 21, class: 4, title: 'VR 外壳', img: require('../assets/img/products/product_21.jpg')},
        {id: 22, class: 4, title: '智能家电象牙白高光组件', img: require('../assets/img/products/product_22.jpg')},
        {id: 23, class: 4, title: '高光外壳', img: require('../assets/img/products/product_23.jpg')},
        {id: 24, class: 4, title: '数据显示器仪表盖', img: require('../assets/img/products/product_24.jpg')},
        {id: 25, class: 10, title: '汽车空调控制面板', img: require('../assets/img/products/product_25.jpg')},
        {id: 26, class: 10, title: '车用控制面板', img: require('../assets/img/products/product_26.jpg')},
        {id: 27, class: 5, title: '户外电动车防水硅胶面板', img: require('../assets/img/products/product_27.jpg')},
        {id: 28, class: 5, title: 'P+R键盘', img: require('../assets/img/products/product_28.jpg')},
        {id: 29, class: 10, title: '橡胶按键数显控制面板', img: require('../assets/img/products/product_29.jpg')},
        {id: 30, class: 5, title: '自动化控制面板', img: require('../assets/img/products/product_30.jpg')},
        {id: 31, class: 5, title: '电脑键盘', img: require('../assets/img/products/product_31.jpg')},
        {id: 32, class: 5, title: '工业控制器硅胶防水键盘', img: require('../assets/img/products/product_32.jpg')},
        {id: 33, class: 3, title: '水晶机顶盒', img: require('../assets/img/products/product_33.jpg')},
        {id: 34, class: 7, title: '名牌车厂遥控器', img: require('../assets/img/products/product_34.jpg')},
        {id: 35, class: 4, title: '便携式手持 POS 机', img: require('../assets/img/products/product_35.jpg')},
        {id: 36, class: 7, title: '线性模组薄膜开关', img: require('../assets/img/products/product_36.jpg')},
        {id: 37, class: 7, title: '智能触摸屏薄膜开关', img: require('../assets/img/products/product_37.jpg')},
        {id: 38, class: 7, title: '智能感应钥匙薄膜开关', img: require('../assets/img/products/product_38.jpg')},
        {id: 39, class: 7, title: '洗衣机薄膜开关', img: require('../assets/img/products/product_39.jpg')},
        {id: 40, class: 7, title: '户外车用薄膜开关', img: require('../assets/img/products/product_40.jpg')},
        {id: 41, class: 7, title: '工业 4.0 采集器薄膜开', img: require('../assets/img/products/product_41.jpg')},
        {id: 42, class: 7, title: '自动化控制触摸屏模组', img: require('../assets/img/products/product_42.jpg')},
        {id: 43, class: 7, title: '3C 照相机触摸屏', img: require('../assets/img/products/product_43.jpg')},
        {id: 44, class: 7, title: '户外防水触摸屏', img: require('../assets/img/products/product_44.jpg')},
        {id: 45, class: 7, title: '透光性感应触摸屏', img: require('../assets/img/products/product_45.jpg')},
        {id: 46, class: 9, title: '四面滑块高精密模具', img: require('../assets/img/products/product_46.jpg')},
        {id: 47, class: 9, title: '高光亮精密零件模具', img: require('../assets/img/products/product_47.jpg')},
        {id: 48, class: 9, title: '双色包胶外壳模具', img: require('../assets/img/products/product_48.jpg')},
        {id: 49, class: 5, title: '透光按键', img: require('../assets/img/products/product_49.jpg')},
        {id: 50, class: 5, title: '透光按键', img: require('../assets/img/products/product_50.jpg')},
        {id: 51, class: 5, title: '码垛机械人控制面板', img: require('../assets/img/products/product_51.jpg')},
        {id: 52, class: 2, title: '光学测距面罩', img: require('../assets/img/products/product_52.jpg')},
        {id: 53, class: 2, title: '智能插座', img: require('../assets/img/products/product_53.jpg')},
        {id: 54, class: 11, title: '防火级硅胶按键', img: require('../assets/img/products/product_54.jpg')},
        {id: 55, class: 11, title: '医疗级支管配件', img: require('../assets/img/products/product_55.jpg')},
        {id: 56, class: 11, title: '医疗级呼吸器面罩', img: require('../assets/img/products/product_56.jpg')},
        {id: 57, class: 11, title: '热显像器握把', img: require('../assets/img/products/product_57.jpg')},
        {id: 58, class: 11, title: '医疗级胶圈', img: require('../assets/img/products/product_58.jpg')},
        {id: 59, class: 11, title: '心电检测仪', img: require('../assets/img/products/product_59.jpg')},
        {id: 60, class: 11, title: '医疗级塞子', img: require('../assets/img/products/product_60.jpg')},
        {id: 61, class: 11, title: '医疗级接管', img: require('../assets/img/products/product_61.jpg')},
      ],
      // 预览dialog
      previewShow: false,
      // 预览dialog需要的链接
      src: '',
    }
  },
  mounted(){
    // 显示footer
    this.showFooter(true)
    // 更改导航条为白色背景及其他
    this.switchHeaderStatus(true)
    this.fixLastFlex()
    this.switchproductList()
  },
  components: {
    CenterImg,
    Card,
    PreviewImg,
},
  methods: {
    switchproductList(){
      console.log(this.currentClass)
      if (this.currentClass === 1) {
        this.productList = this.allProducts
        return
      }
      this.productList = this.allProducts.filter(item => item.class === this.currentClass)
    },
    // 分类点击
    classClick(param){
      this.classList.forEach(item => item.selected = false)
      param.selected = true
      this.currentClass = param.id
      console.log(this.currentClass)
      this.switchproductList()
    },
    // 产品点击
    cardClick(param){
      this.previewShow = true
      this.src = param.img
    },
    // 为最后一行flex左对齐
    fixLastFlex(){
      const length = this.productList.length
      const resiue = length % 3
      // console.log(length)
      /* 8 -> 9  7 ->  9   8/3=2--2 2+1 *3 9 9-length*/
      if (length !== 0 && resiue !== 0) {
        const rate = Math.floor((length / 3 + 1)) * 3 - length
        for(let i =0; i<rate; i++){
          this.productList.push({temp:true})
        }
        console.log(this.productList.length)
      }
    }
  },
}
